import type { HTTPMethod } from '@ff-it/api';
import { api } from 'services';
import type { ClientDiscountSaveInput, ClientDiscountRuleWrite, ClientDiscountTarget } from '../discounts/types';

/** Discount mutations refresh their own collection, preserving sibling terms drafts. */
export function clientDiscountMutations(url: string, refresh: () => Promise<void>) {
  const request = async (method: HTTPMethod, path: string, body?: unknown) => {
    const response = await api.request({ method, url: `${url}${path}`, ...(body === undefined ? {} : { body }) });
    if (!response.ok) throw response;
    await refresh();
  };
  return {
    removeRoot: (rootId: number) => request('DELETE', `vendor-terms/${rootId}/`),
    saveRule: (input: ClientDiscountSaveInput, ruleId?: number, rootId?: number) => {
      const { target_path, ...values } = input;
      const endpoint = target_path[target_path.length - 1]!;
      const body: ClientDiscountRuleWrite = {
        ...values,
        target: { kind: endpoint.kind, id: endpoint.id },
        ...(ruleId === undefined && rootId !== undefined ? { root_id: rootId } : {}),
      };
      return request(
        ruleId === undefined ? 'POST' : 'PUT',
        `discount-rates/${ruleId === undefined ? '' : `${ruleId}/`}`,
        body,
      );
    },
    removeRule: (ruleId: number) => request('DELETE', `discount-rates/${ruleId}/`),
    reorderRules: (root_id: number, target: ClientDiscountTarget, rate_ids: readonly number[]) =>
      request('POST', 'discount-rates/reorder/', { root_id, target, rate_ids }),
  };
}
